import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateAccountComponent } from './create-account/create-account.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import {MagicLinkComponent} from './magic-link/magic-link.component';
import { LoginComponent } from './login/login.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { Ng9PasswordStrengthBarModule } from 'ng9-password-strength-bar';
import { SocialLoginModule } from 'angularx-social-login';
import { SharedCoreModule } from 'src/app/shared-core/shared-core.module';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  declarations: [CreateAccountComponent, ForgetPasswordComponent, MagicLinkComponent, LoginComponent],
  imports: [
    RecaptchaModule,
    Ng9PasswordStrengthBarModule,
    SocialLoginModule,
    CommonModule,
    SharedCoreModule,
    AngularSvgIconModule
  ],
  exports: [CreateAccountComponent, ForgetPasswordComponent, MagicLinkComponent, LoginComponent],
})
export class AccountModule {}
